import isPropValid from "@emotion/is-prop-valid";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { faChevronDown, faTimes } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/pro-light-svg-icons";
import Flex from "@ternary/api-lib/ui-lib/components/Flex";
import Icon from "@ternary/api-lib/ui-lib/components/Icon";
import Text from "@ternary/api-lib/ui-lib/components/Text";
import Divider from "@ternary/web-ui-lib/components/Divider";
import React, { forwardRef } from "react";

const StyledSelect = styled("div", {
  shouldForwardProp: (propName) => isPropValid(propName),
})(({ theme }) => ({
  alignItems: "center",
  borderColor: theme.secondary_color_border,
  borderStyle: "solid",
  borderWidth: "1px",
  borderRadius: theme.borderRadius_2,
  cursor: "pointer",
  display: "flex",
  height: "38px",
  justifyContent: "space-between",
  paddingLeft: theme.space_xs,
  paddingRight: theme.space_xs,
  width: "100%",

  "&:hover": {
    borderColor: theme.primary_color_border,
  },

  "&:focus": {
    borderColor: "transparent",
    boxShadow: `0 0 0 2px ${theme.primary_color_focus}`,
  },
}));

interface Props {
  value?: string;
  onClear?: () => void;
  onClick?: () => void;
}

export const CustomSelectInput = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const theme = useTheme();

    return (
      <StyledSelect ref={ref} tabIndex={-1} onClick={props.onClick}>
        <Flex alignItems="center">
          <Icon icon={faCalendar} />
          <Text
            color={theme.text_color_placeholder}
            marginLeft={theme.space_sm}
          >
            {props.value ? props.value : "Select"}
          </Text>
        </Flex>
        <Flex alignItems="center">
          {props.value !== "Select" ? (
            <>
              <Icon
                clickable
                color={theme.text_color_placeholder}
                icon={faTimes}
                onClick={props.onClear}
              />
              <Divider
                direction="vertical"
                margin={theme.space_sm}
                minHeight={20}
              />
            </>
          ) : null}
          <Icon
            clickable
            color={theme.text_color_placeholder}
            icon={faChevronDown}
          />
        </Flex>
      </StyledSelect>
    );
  }
);
